module.exports = __webpack_public_path__ + "img/base_nature_nature.abe46d5c.svg";